<template>
  <v-layout class="mission-container" column style="min-height: 100%;" v-if="missionGlobal && simulationState">       
     <v-tabs align-with-title slider-color="#ddd">                
     <v-tab class="missiontab" exact :to="'/smartplanning/'+simId" v-for="simId in detailSimulations" :key="simId">        
       {{ missionGlobalsById[simId].MIG_LIBELLE }}
       <v-spacer /><v-btn class="mr-0" small icon @click.prevent.stop="$store.myActions.MISSIONGLOBAL_UNSELECT_DETAIL(simId)" :title="$t('Simulation.CloseMissionTabTooltip')"><v-icon small>mdi-close</v-icon></v-btn>
     </v-tab>
     <v-tab class="missionmore" exact to="/smartplanning" :title="$t('Simulation.AddSimulationTabTooltip')"><v-icon>mdi-plus</v-icon></v-tab>      
     <v-spacer />
     <v-tab exact to="/smartplanning">{{$t('Simulation.BackToList')}}</v-tab>
   </v-tabs>        
   <v-flex v-if="missionGlobal" class="mission-page"  >         
    <multipane :style="{ flexGrow: 1 }" class="custom-resizer my-2" @paneResizeStop="panResized" layout="vertical">        
      <simulation-detail :isleft="true" class="mission-infos border-box elevation-2 ml-2" :class="{transition:isTransitionActive}" :style="{width:simulationState.leftPanelWidth,flex:'0 0 auto'}" />        
      <multipane-resizer class="pa-1">
        <v-btn @click="resizePaneLeft('0px')" icon class="toggle-left" :title="$t('Pilot.MissionInfos.ExpandRightPanelTooltip')"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <br/>
        <v-btn @click="resizePaneLeft('50%')" icon class="toggle-left" :title="$t('Pilot.MissionInfos.EqualRightLeftPanelTooltip')">||</v-btn>
        <br/>
        <v-btn @click="resizePaneLeft('calc(100% - 22px)')" icon class="toggle-right" :title="$t('Pilot.MissionInfos.ExpandLeftPanelTooltip')"><v-icon>mdi-chevron-right</v-icon></v-btn>
      </multipane-resizer>                
      <simulation-detail :isleft="false" class="mission-infos border-box elevation-2 mr-2" style="flex:1 1 auto;overflow:auto" />                                     
    </multipane>
   </v-flex>         
 </v-layout> 
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import Multipane from '@/components/shared/multipane/multipane.vue'
import MultipaneResizer from '@/components/shared/multipane/multipane-resizer.vue'   
import SimulationDetail from '@/components/smart/SimulationDetail.vue'   
import SimulationMap from '@/components/map/SimulationMap.vue'

import MapControl from '@/components/map/MapControl.vue'

import { buildSimulationUIStateId,SimulationUiState } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { UI_SET_LEFTPANEL_SIZE } from '@/store/modules/ui/mutation-types'
import { DETAIL_REFUSED } from '@/utils/tenantModules'
 
@Component({
 name: 'SimulationDetailPage', 
 props: {
   simulationid:Number
 },
 components:{Multipane,MultipaneResizer,SimulationDetail,SimulationMap,MapControl}
})
export default class SimulationDetailPage extends Vue {      
 
 simulationid!:number
 isTransitionActive = false

 get currentDetailMission(){
  return this.$store.myGetters.currentDetailMission
 }

 // BLF037 — onglets des seuls scénarios autorisés pour leur enseigne (RG-ACC-050).
 get detailSimulations() {
   return this.$store.myGetters.allowedDetailSimulations
 }
 
 @Watch('detailSimulations')
 onDetailSimulationsChanged(newValue:Array<number>){      
   //si l'onglet fermé est l'onglet en cours on navigue sur la premiere page        
   if(this.simulationid && newValue.findIndex(id => id == this.simulationid) == -1) {          
     this.$router.push('/smartplanning/'+(newValue.length > 0?newValue[0]:""))
   }        
 }  

 @Watch('simulationid')
 onSimulationIdChanged(){
   this.openSimulation()
 }  

 created() {         
   this.openSimulation()
 }

 // BLF037 — scénario refusé par les réglages de son enseigne : « introuvable », retour à la liste.
 openSimulation() {
   this.$store.myActions.MISSIONGLOBAL_OPEN_DETAIL(this.simulationid).catch((err: unknown) => {
     if ((err as Error)?.message !== DETAIL_REFUSED) throw err
     this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.$t('Simulation.NotFound') as string)
     this.$router.replace('/smartplanning')
   })
 }


 get missionGlobalsById(){
   return this.$store.myGetters.missionGlobalsById
 }

 get missionGlobal() {        
   return this.$store.myGetters.modifiedAdmMissionGlobal
 }

 
 get simulation_uiid() {
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
 }

 get uistatebyuiid(){
   return this.$store.myGetters.uistatebyuiid
 }

 //recupere le state de travail
 get simulationState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
 }
  
 get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

 get isDrawerOpen(){
  return this.$store.myGetters.isDrawerOpen
 }
 get isRightDrawerOpen(){
  return this.$store.myGetters.isRightDrawerOpen
 }  

 get simMissions(){
   return this.missionGlobal.misIdArray.map(id => this.missionVirtualsById[id]).filter(m => !!m)
 }

 get clipped(){
    return this.$vuetify.breakpoint.name == 'xs' ||
          this.$vuetify.breakpoint.name == 'sm'
  }

  get showDrawer() {        
          return this.isDrawerOpen
  }        
  set showDrawer(newValue) {
      this.$store.myActions.UI_SET_DRAWER_VISIBILITY(newValue)        
  }

  get showRightDrawer(){         
    return this.isRightDrawerOpen
  }

  set showRightDrawer(newValue) {          
    this.$store.myActions.UI_SET_RIGHT_DRAWER_VISIBILITY(newValue)
  }


 resizePaneLeft(size:string) {
    //force la transition
    this.isTransitionActive = true
    this.$store.myActions.UI_SET_LEFTPANEL_SIZE({uiid:this.simulation_uiid,size})    
    //desactive la transition
    setTimeout(() => {          
      this.isTransitionActive = false
    }, 250);
  }

  panResized(pane:any, resizer:any, size:string) {     
    this.$store.myActions.UI_SET_LEFTPANEL_SIZE({uiid:this.simulation_uiid,size})
  }

  toggleRightDrawer() {        
    if(this.clipped) this.showDrawer = false
    this.showRightDrawer = !this.showRightDrawer
  }
}
</script> 

<style scoped>
 .btnClose{
   position: sticky;
   top:0px;
   right:0px;
   background: #ddd;
 }
 .data{
   color:  var(--primary-color);
   padding: 0 10px;
 }
 .toggle-left,.toggle-right {
   left:0px;
   margin: 0px;
   padding: 0px;     
   max-width: 100%;
   position:relative;
 }

 .transition{
   transition: all 250ms ease;
 }

 .mission-page{
   background-color:#ddd;
   display:flex;
   flex-direction:column;
   flex-grow:1
 }

 .mission-infos {
   background-color:#f4f4f4;
 }

 .mission-resume{
   
   white-space: nowrap;
   overflow-x: auto;
 }

</style>